import {useState} from 'react'

import {useRouteQuery} from '@github-ui/react-core/future/use-route-query'
import {useSearchParams} from '@github-ui/use-navigate'

import {mcpRegistryRoute} from '../mcp-registry-route'

import {Content} from './_components/Content/Content'
import {Header} from './_components/Header/Header'

export function McpRegistry() {
  const payload = useRouteQuery(mcpRegistryRoute, 'mainQuery')
  const [searchParams, setSearchParams] = useSearchParams()

  // v0.1 API uses 'search' parameter
  const searchParamKey = 'search'
  const [searchQuery, setSearchQuery] = useState(searchParams.get(searchParamKey) || '')

  const handleSearchChange = (query: string) => {
    setSearchQuery(query)

    // Update URL search params to trigger server-side search
    const newSearchParams = new URLSearchParams(searchParams)
    if (query.trim()) {
      newSearchParams.set(searchParamKey, query.trim())
    } else {
      newSearchParams.delete(searchParamKey)
    }

    // Reset page when search changes (v0.1 API uses page-based pagination)
    newSearchParams.delete('page')

    setSearchParams(newSearchParams, {preventAutofocus: true})
  }

  return (
    <>
      <Header searchQuery={searchQuery} onSearchChange={handleSearchChange} />
      <Content key={searchParams.get(searchParamKey) || 'all'} data={payload.data.serversData} />
    </>
  )
}
